import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderDate: "",
    orderForm: 52,
    orderStatus: 1,
    serviceOption: "",
    servicePriority: 0,
    sampleAmount: 2,
    additionalComments: "",
    tableData: [],
  },
};

//creates the user slice with the initial state and actions
const freeTrialSliceWPS = createSlice({
  name: "freetrialWPS",
  initialState,
  reducers: {
    //action creators
    initializeFreeTrialDataWPS(state, action) {
      for (let i = 0; i < state.data.sampleAmount; i++) {
        const newObj = {
          id: i + 1,
          sampleID: "",
          sampleConc: "",
          sampleType: "",
          targetSize: '',
          dataAnalysis: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    setFreeTrialSampleAmountWPS(state,action){
      state.data.sampleAmount = 10
      for (let i = 2; i <= 3; i++) {
        const newObj = {
          id: i + 1,
          sampleID: "",
          sampleConc: "",
          sampleType: "",
          targetSize: '',
          dataAnalysis: "",
          orderId: 0,
        };
        state.data.tableData.push(newObj);
      }
      return
    },
    resetFreeTrialStateWPS(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetFreeTrialPageWPS(state, action) {
      state.page = action.payload;
      return;
    },
    editFreeTrialRowWPS(state, action) {
      const { index, value, property } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;
      const updatedData = [...state.data.tableData];

      if (property === "sampleID") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert("Only special characters allowed: hyphen( - ) and underscore( _ ).");
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    increaseFreeTrialConcentrationWPS(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] = Number(state.data.tableData[index][property]) + 1;
    },
    decreaseFreeTrialConcentrationWPS(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] = Number(state.data.tableData[index][property]) - 1;
      }
    },
    editFreeTrialCommentsWPS(state, action) {
      state.data.additionalComments = action.payload;
    },
    clearFreeTrialSelectWPS(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    freeTrialPrevStepWPS: (state, action) => {
      state.page = state.page - 1;
    },
    freeTrialNextStepWPS: (state, action) => {
      state.page = state.page + 1;
    },
    setFreeTrialOrderNumberWPS: (state, action) => {
      state.data.orderNumber = action.payload
    }
  },
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return [];
    });
  },
});

export const {
  initializeFreeTrialDataWPS,
  setFreeTrialSampleAmountWPS,
  resetFreeTrialStateWPS,
  resetFreeTrialPageWPS,
  editFreeTrialRowWPS,
  increaseFreeTrialConcentrationWPS,
  decreaseFreeTrialConcentrationWPS,
  editFreeTrialCommentsWPS,
  clearFreeTrialSelectWPS,
  freeTrialNextStepWPS,
  setFreeTrialOrderNumberWPS,
  freeTrialPrevStepWPS,
} = freeTrialSliceWPS.actions;
export const freeTrialReducerWPS = freeTrialSliceWPS.reducer;
